import React from 'react';
import { Mic, CameraVideo, Display, CircleFill } from 'react-bootstrap-icons';

const PREVIEW_TURNS = [
  {
    role: 'user',
    text: 'I’m stuck on question four — it’s here on my screen.',
  },
  {
    role: 'assistant',
    text: 'I can see it. Before we touch any numbers — what is the question actually asking you to find?',
  },
  {
    role: 'user',
    text: 'The area, I think?',
  },
  {
    role: 'assistant',
    text: 'That’s it. So which two measurements has it already given you?',
  },
];

export default function LivePreview() {
  return (
    <div className="relative mx-auto w-full max-w-md lg:max-w-none">
      <div className="overflow-hidden rounded-card border border-brand-line bg-[#202123] shadow-brand-lg">
        <div className="flex items-center gap-2 border-b border-white/10 px-4 py-3">
          <CircleFill size={9} className="animate-pulse text-[#ff5f57]" />
          <span className="text-xs font-semibold text-[#ececf1]">
            Live with SchoolCracked
          </span>
          <span className="ml-auto text-[11px] text-white/40">Screen sharing</span>
        </div>

        <div className="space-y-2.5 px-4 py-4">
          {PREVIEW_TURNS.map((turn) => (
            <div
              key={turn.text}
              className={
                turn.role === 'user'
                  ? 'ml-6 rounded-xl bg-[#40414f] px-3 py-2'
                  : 'mr-6 rounded-xl bg-[#0da37f]/15 px-3 py-2'
              }
            >
              <span className="mb-0.5 block text-[9px] font-semibold uppercase tracking-wide text-white/40">
                {turn.role === 'user' ? 'You' : 'SchoolCracked'}
              </span>
              <span className="text-[13px] leading-relaxed text-[#ececf1]">
                {turn.text}
              </span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-2.5 border-t border-white/10 px-4 py-3.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#0da37f] bg-[#0da37f]/20 text-[#0da37f]">
            <Mic size={16} />
          </span>
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/50">
            <CameraVideo size={16} />
          </span>
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#0da37f] bg-[#0da37f]/20 text-[#0da37f]">
            <Display size={16} />
          </span>
        </div>
      </div>

      <div
        className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-brand-mint/30 blur-2xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-8 -left-8 h-28 w-28 rounded-full bg-brand-violet/25 blur-2xl"
        aria-hidden
      />
    </div>
  );
}
